<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="prt01"></a>
<a id="page_33"></a>
<h2 class="partnum" id="p_1">PART 1</h2>
<h2 class="parttitle" id="p_2">The Human Person, the Political Community, and the Common Good</h2>
<a id="page_34"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?2aaa8e0e